/**
 * Open state of the Help & learning sheet, the welcome and the shortcuts
 * dialog, so the header button, F1, the /help route, the learning-path
 * toasts and the tours can open or close them.
 */

import { create } from "zustand";

interface HelpUiState {
  open: boolean;
  /** "path" | "tours" | "handbook" | "article:<id>" */
  view: string;
  welcomeOpen: boolean;
  shortcutsOpen: boolean;
  /** Opens the sheet; without a view it shows the last one. */
  openHelp: (view?: string) => void;
  closeHelp: () => void;
  setWelcomeOpen: (open: boolean) => void;
  setShortcutsOpen: (open: boolean) => void;
}

export const useHelpUi = create<HelpUiState>()((set) => ({
  open: false,
  view: "path",
  welcomeOpen: false,
  shortcutsOpen: false,
  openHelp: (view) => set((s) => ({ open: true, view: view ?? s.view })),
  // the sheet may report its close twice (Esc, then the dialog's close event)
  closeHelp: () => set((s) => (s.open ? { open: false } : s)),
  setWelcomeOpen: (welcomeOpen) => set({ welcomeOpen }),
  setShortcutsOpen: (shortcutsOpen) => set({ shortcutsOpen }),
}));
